import axios from "axios";

export const ACCESS_TOKEN = "token";
export const BRANCH = "branch";

export const api = axios.create({
  baseURL: process.env.REACT_APP_PRODUCTION_URL,
  headers: {
    Accept: "application/json",
    Pragma: "no-cache",
  },
});

// Adds bearer token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN);
  const branch = localStorage.getItem(BRANCH);
  if (config?.headers) {
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (branch) {
      config.headers["branch"] = branch;
    }
    if (process.env.NODE_ENV === "development") {
      config.headers["organization"] = process.env.REACT_APP_DOMEN as string;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
    }
    throw error;
  }
);

export const setAccessTokenToLocalStorage = (token: string) => {
  localStorage.setItem(ACCESS_TOKEN, token);
};

export const getAccessTokenFromLocalStorage = () => {
  return localStorage.getItem(ACCESS_TOKEN);
};
